/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { totalSupplySeriesApiV1LedgersLedgerCanisterIdTotalSupplyGet } from "../../funcs/totalSupplySeriesApiV1LedgersLedgerCanisterIdTotalSupplyGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .SeriesApiV1LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema,
};

export const tool$totalSupplySeriesApiV1LedgersLedgerCanisterIdTotalSupplyGet:
  ToolDefinition<typeof args> = {
    name: "total-supply-v1",
    description: `Retrieve total supply series metrics for a token

Original tool name: api-v1-ledgers-ledger-canister-id-total-supply-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalSupplySeriesApiV1LedgersLedgerCanisterIdTotalSupplyGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };